module.exports = __webpack_public_path__ + "assets/b16696bc91f825197813166838c59a9f.mp3";